<template>
  <div v-if="advertsRes" class="main_banner">
    <div class=" div_1">
      <el-carousel v-if="advertsRes" trigger="click" height="100px" autoplay :interval="5000">
        <el-carousel-item v-for="(item, index) in advertsRes.adverts" :key="index">
          <div class="x_y_center div_2 cursor_pointer" @click="onAdvertClick(item.url)">
            <img :src="item.attachments ? item.attachments + '!960':''" alt="" style="width:100%">
            <!-- <span class="span_1 bc_0983CC c_fff fz16 font_w_bold">
              点击进入
            </span> -->
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {

    code: { // 广告编码
      type: String,
      default: ''
    }
  },
  data() {
    return {
      advertsRes: null
    }
  },
  computed: {
    ...mapGetters(['siteInfo', 'indexAdverts'])
  },
  watch: {
    indexAdverts:{
      handler(n){
        if(n){
          this.advertsRes = this.indexAdverts.find(i => i.code === this.code)
        }
      },
      immediate:true
    }
  },
  created() {

  },
  methods: {

    // 点击广告跳转
    onAdvertClick(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.main_banner {
  margin-bottom: 20px;
  .div_1 {
    width: 1199px;
    height: 100px;
    margin: 0 auto;
    background-color: #ccc;
  }
  .div_2 {
    position: relative;
    height: 100%;
  }
  .span_1{
    position: absolute;
    top: 0;
    bottom: 0;
    right: 335px;
    height: 30px;
    line-height: 30px;
    padding: 0 30px;
    margin: auto 0;
    cursor: pointer;
  }
}
</style>
